import axios from 'axios';

const api = axios;

// Централизованная обработка ошибок
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {

        }
        return Promise.reject(error);
    }
);

export default api;
